import { useNotification } from '@/shared/ui'
import { useHttp, useTranslate } from '@/shared/lib'
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import type { ScheduleTreeItemType } from '@/entities/SchedulesTree/model/types.ts'

export const useScheduleDelete = () => {
  const { addError, addSuccess } = useNotification()
  const http = useHttp()
  const { trs } = useTranslate()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (data: number) => http.del(`/schedules/${data}`, data),
  })

  /* Отправка формы */
  const remove = async (data: ScheduleTreeItemType) => {
    try {
      await mutation.mutateAsync(data.id)

      addSuccess(trs('itf.schedules_deleted'))

      await queryClient.fetchQuery({
        queryKey: ['load_schedules_tree', data.parent],
      })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    remove,
  }
}
